<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="sAPCustomerMaterialMapping.pkid ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="sAPCustomerMaterialMapping"
        :rules="ruleValidate"
        class="form"
        label-width="100px">
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model="sAPCustomerMaterialMapping.customerName" placeholder="请选择客户" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectCustomer.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="客户物料名称" prop="customerMaterialName">
        <el-input v-model="sAPCustomerMaterialMapping.customerMaterialName" placeholder="请输入客户物料名称"/>
      </el-form-item>
      <el-form-item label="客户物料编号" prop="customerMaterialNo">
        <el-input v-model="sAPCustomerMaterialMapping.customerMaterialNo" placeholder="请输入客户物料编号"/>
      </el-form-item>
      <!--      <el-form-item label="客户物料单位">-->
      <!--        <el-input v-model="sAPCustomerMaterialMapping.unit" placeholder="请输入客户物料单位"/>-->
      <!--      </el-form-item>-->
      <el-form-item label="客户物料规格">
        <el-input v-model="sAPCustomerMaterialMapping.customerMaterialSpecification" placeholder="请输入客户物料规格"/>
      </el-form-item>
      <el-form-item label="物料名称" prop="materialDesc">
        <el-input v-model="sAPCustomerMaterialMapping.materialDesc" placeholder="请选择物料" readonly>
          <el-button slot="append" icon="el-icon-search" @click="$refs.selectMateriaManagement.open()"/>
        </el-input>
      </el-form-item>
      <el-form-item label="物料编号">
        <el-input v-model="sAPCustomerMaterialMapping.materialNo" disabled/>
      </el-form-item>
      <el-form-item label="规格型号">
        <el-input v-model="sAPCustomerMaterialMapping.specification" disabled/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit"> 确定 </el-button>
    </span>
    <!-- 客户选择 -->
    <customer-select ref="selectCustomer" @select="selectCustomer"/>
    <!-- 物料选择 -->
    <material-select ref="selectMateriaManagement" @select="selectMateriaManagement"/>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "../Customer/CustomerSelect";
  import MaterialSelect from "../Material/MaterialSelect";

  export default {
    name: "CustomerMaterialMappingEdit",
    components: {MaterialSelect, CustomerSelect},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        sAPCustomerMaterialMapping: {
          pkid: "",
          customerId: "",
          customerNo: "",
          customerName: "",
          materialId: "",
          materialNo: "",
          materialDesc: "",
          customerMaterialNo: "",
          customerMaterialName: "",
          customerMaterialSpecification: "",
          unit: "",
          price: "",
        },
        ruleValidate: {
          customerName: {required: true, message: "请选择客户", trigger: "change"},
          customerMaterialName: {required: true, message: "请输入客户物料名称", trigger: "blur"},
          customerMaterialNo: {required: true, message: "请输入客户物料编号", trigger: "blur"},
          materialDesc: {required: true, message: "请选择物料", trigger: "change"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.sAPCustomerMaterialMapping = Object.assign(this.sAPCustomerMaterialMapping, row);
        }
      },

      // 选择客户
      selectCustomer(row) {
        this.sAPCustomerMaterialMapping.customerId = row.customerID;
        this.sAPCustomerMaterialMapping.customerName = row.customerName;
        this.sAPCustomerMaterialMapping.customerNo = row.outerNo;
      },

      // 选择物料
      selectMateriaManagement(row) {
        this.sAPCustomerMaterialMapping.materialId = row.materialID;
        this.sAPCustomerMaterialMapping.materialNo = row.materialNO;
        this.sAPCustomerMaterialMapping.materialDesc = row.materialName;
        this.sAPCustomerMaterialMapping.price = row.price;
      },

      // 确定
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "customerMaterialMappings", this.sAPCustomerMaterialMapping)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.sAPCustomerMaterialMapping.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
